<template>
   <div class="head-line">
    <div class="hl-line"></div>
    <div class="hl-txt">{{lineText}}</div>
  </div>
</template>

<script>
export default {
  props: {
    lineText: {
      type: String,
      required: true,
      default: ''
    }
  }
}
</script>

<style scoped>
.head-line{
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 4% 3%;
  background: #fff;
  font-weight: 600;
  text-align: left;
}
.hl-line{
  display: inline-block;
  height: 18px;
  width: 5px;
  border-radius: 4px;
  background: #F43530;
}
.hl-txt{
  text-indent: 0.5em;
  font-size: 15px;
}
</style>
